import React from 'react';
import {usePrefix} from '../hooks';
import {InputProps} from '../types';

function withPrefix<P extends InputProps>(
	Component: React.ComponentType<P>,
): React.ForwardRefRenderFunction<HTMLInputElement, P & {prefix: string}> {
	// @ts-ignore
	return React.forwardRef((props, ref) => {
		// @ts-ignore
		return <Component {...usePrefix({ref, ...props})} />;
	});
}

export default withPrefix;
